import React from "react";

const MainComponent = () => {
  return <div>321</div>;
};

export const Main = React.memo(MainComponent);
